import { getIsCohortUserIdentifierIntegration } from '@modules/integrationsV2/utils';
import {
  IntegrationChannelType,
  IntegrationViewFragment,
} from 'generated/graphql';

interface GetIsCohortIntegrationAlreadyConnectedParams {
  connectedIntegrations: IntegrationViewFragment[];
  channelType: IntegrationChannelType;
}

export const getIsCohortIntegrationAlreadyConnected = ({
  connectedIntegrations,
  channelType,
}: GetIsCohortIntegrationAlreadyConnectedParams) => {
  const activeCohortIntegrations = connectedIntegrations.filter(
    (integration) =>
      getIsCohortUserIdentifierIntegration({
        channelType: integration.channel.type,
        integrationType: integration.integrationType,
      }) && integration.isActive,
  );

  return Boolean(
    activeCohortIntegrations.find(
      (integration) => integration.channel.type === channelType,
    ),
  );
};
